import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function HistoricalPercentageChangeCapsuleCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                Display historical price and volume data. Click on each bar for
                a label view.
            </div>
        </IconTooltip>
    );
}
